import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Flex,
  notification,
  PaginationProps,
  SelectProps,
  Table,
  TableColumnsType,
  Tooltip,
  Input,
  Select,
  Checkbox,
} from "antd";
import {
  DocumentDownload,
  Home2,
  DollarCircle,
  DocumentText,
  SearchZoomIn1,
  ArrowSquareDown,
  Category2,
} from "iconsax-react";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { mixGetV1, mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
import "./StoreList.scss";
import DeleteModal from "../../components/Modal/DeleteModal";

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const RenewList: React.FC = () => {
  const [visibleTooltipId, setVisibleTooltipId] = useState<string | null>(null);
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchRenewer, setSearchRenewer] = useState("");
  const [serviceTypes, setServiceTypes] = useState([] as any);
  const [showDeleteStaffPopup, setShowDeleteStaffPopup] = useState(false);
  const [selectedId, setSelectedId] = useState<number>();
  const [saleName, setsaleName] = useState("");
  const getStoreTypes = async () => {
    try {
      const res = await mixGetV1("/api/webAdmin/gComboTypeStore.php");

      if (res.status === 1) {
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            value: item.type_id,
            label: item.type_name,
          })
        );
        setServiceTypes(result);
      }
    } catch (error) {}
  };
  type LabelRender = SelectProps["labelRender"];
  const customSelectedLabel: LabelRender = (props) => {
    const { label, value } = props;

    if (value && label) {
      return (
        <Flex align="center" gap={8}>
          <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
          <span>{label}</span>
        </Flex>
      );
    }
    return (
      <Flex align="center" gap={8}>
        <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
        <span>Type</span>
      </Flex>
    );
  };
  // const handleTooltipChange = (visible: boolean, recordId: string) => {
  //   if (visible) {
  //     setVisibleTooltipId(recordId);
  //     // auto-close tooltip sau 2s
  //     timeoutRef.current = setTimeout(() => {
  //       setVisibleTooltipId(null);
  //     }, 2000);
  //   } else {
  //     if (timeoutRef.current) clearTimeout(timeoutRef.current);
  //     setVisibleTooltipId(null);
  //   }
  // };
  // role_id: 1:admin, 2:owner, 3:sales, 4:user
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const roleId: any = user.role_id;

  // const updatePaidStatus = async (pay_id: number, checked: boolean) => {
  //   try {
  //     const res = await mixPostV1("/api/webAdmin/updateAlreadyPaidrenew.php", {
  //       pay_id,
  //       already_paid: checked ? 1 : 0,
  //     });
  //     if (res.status === 1) {
  //       openNotification("success", "Update paid status successfully!");
  //       getItems();
  //     } else {
  //       openNotification("error", res.message);
  //     }
  //   } catch (error) {
  //     openNotification("error", "Oops, something went wrong!");
  //   }
  // };
  const columns: TableColumnsType = [
    {
      title: "Store ID",
      dataIndex: "store_id",
      key: "store_id",
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "Paid At",
      dataIndex: "create_at",
      key: "create_at",
    },
    {
      title: "Payment Method",
      dataIndex: "pay_method_name",
      key: "pay_method_name",
    },
    {
      title: "Type",
      dataIndex: "type_name",
      key: "type_name",
    },
    {
      title: "Owner Name",
      dataIndex: "owner_name",
      key: "owner_name",
    },
    // {
    //   title: "Owner Phone",
    //   dataIndex: "phone_number",
    //   key: "phone_number",
    // },
    {
      title: "Amount",
      dataIndex: "income",
      key: "income",
    },
    {
      title: "Renewer ID",
      dataIndex: "renewer_id",
      key: "renewer_id",
    },
    {
      title: "Renewer Name",
      dataIndex: "renewer_name",
      key: "renewer_name",
    },
    {
      title: "Renewer role",
      dataIndex: "role_name",
      key: "role_name",
    },
    {
      title: "Already paid",
      dataIndex: "already_paid",
      key: "already_paid",
      align: "center",
      render: (text, record) => (
        <Checkbox
          className="rs-input"
          checked={record.already_paid === 1}
          onChange={(e) => {
            if (
              record.already_paid === 1 ||
              record.renewer_role === 1 ||
              roleId !== 1
            ) {
              e.preventDefault();
            } else {
              setSelectedId(record.pay_id);
              setsaleName(record.renewer_name);
              setShowDeleteStaffPopup(true);
            }
            // chặn thay đổi
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    getItems();
    getStoreTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    name_or_phone?: number | string;
    type?: number | string;
    searchRenewer?: string | number;
  }>({
    limit: 10,
    page_number: 1,
    name_or_phone: "",
    type: "",
    searchRenewer: "",
  });

  const getItems = async () => {
    setTableLoading(true);
    let res;

    res = await mixPostV1("/api/webAdmin/gListRenew.php", params);

    if (res.status === 1) {
      setItems({
        ...items,
        list: res.data,
        total: res.total,
      });
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST
  const onSearch = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      name_or_phone: query,
    });
  };
  const onSearchRenewer = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchRenewer: query,
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    setSearchQuery(e.target.value);
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };
  const onChangeRenewer = (e: any) => {
    setSearchRenewer(e.target.value);
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearchRenewer(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };
  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1("/api/webAdmin/gListRenew.php", customParams);

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "Store ID": item.store_id,
        "Store name": item.store_name,
        "Paid At": item.create_at,
        "Payment Method": item.pay_method_name,
        Type: item.type_name,
        "Owner Name": item.owner_name,
        Amount: item.income,
        // 'Sent SMS': item.sent_sms || '',
        "Renewer ID": item.renewer_id,
        "Renewer Name": item.renewer_name,
        "Renewer role": item.role_name,
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Live Store"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!"
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="store-list-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Renew History" },
          ]}
          title="Renew History"
          description=""
        />

        <div className="table-filter-block">
          <Input
            placeholder="Search by ID or name renewer"
            value={searchRenewer}
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            allowClear
            className="rs-input table-filter-block__search"
            onChange={(e) => onChangeRenewer(e)}
          />
          <Input
            placeholder="Search by ID or name store"
            value={searchQuery}
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            allowClear
            className="rs-input table-filter-block__search"
            onChange={(e) => onChange(e)}
            onPressEnter={(e) => onEnter(e)}
          />
          <Select
            allowClear={params.type !== ""}
            value={params.type}
            options={serviceTypes}
            placeholder="Type"
            popupMatchSelectWidth={false}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            labelRender={customSelectedLabel}
            className="rs-select mw-173 mw-100-767 grid-area-type"
            popupClassName="rs-select-dropdown"
            onChange={(value) =>
              setParams({
                ...params,
                type: value ? Number(value) : "",
                page_number: 1,
              })
            }
          />
          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button mis-auto grid-area-export"
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={items.list}
          className="rs-table table-text-nowrap match-height"
          loading={tableLoading}
          rowKey="store_id"
          scroll={{
            x: true,
          }}
          pagination={{
            pageSize: params.limit,
            current: params.page_number,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange(e),
          }}
          onChange={onTableChange}
        />
        <DeleteModal
          isShow={showDeleteStaffPopup}
          content={`Are you sure this salesperson has already paid? ${saleName}`}
          message="Confirm Payment"
          deleteApi="/api/webAdmin/updateAlreadyPaidrenew.php"
          deleteId={selectedId}
          deleteKey="pay_id"
          onModalClose={() => setShowDeleteStaffPopup(false)}
          yesText="Yes, I'm sure"
          noText="No"
          is_post={true}
          onModalSubmit={() => {
            getItems();
            setShowDeleteStaffPopup(false);
          }}
        />
      </Layout>
    </>
  );
};

export default RenewList;
